import { CircularProgress, Stack } from '@mui/material';
import React from 'react';

export const LoadingCircle = () => (
    <Stack direction={'column'} alignItems={'center'} justifyContent={'center'} height={'100%'} minHeight={'100px'}>
        <CircularProgress color="inherit" />
    </Stack>
);
